import React, {useState} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTimes, faChevronRight} from '@fortawesome/pro-solid-svg-icons'
import '../styles/banner.scss'

const Banner = (props) => {
    const [isVisible, makeHidden] = useState(true)

    function hideBanner(e) {
        e.preventDefault()
        makeHidden(false)
    }

    if (isVisible) {
        return (
            <div className="banner">
                <span className="banner__text">{props.text}</span>
                <a href={props.link} className="banner__cta">
                    {props.cta}
                    <FontAwesomeIcon icon={faChevronRight}/>
                </a>
                <a href="#" id="banner-close" className="banner__close" onClick={hideBanner}>
                    <FontAwesomeIcon icon={faTimes} size="2x"/>
                </a>
            </div>
        )
    } else {
        return null
    }
}

export default Banner